import { useAppSelector } from 'reduxTyped'
import { FolderMissingError } from 'apps/cms/errors'
import { contentManagementSelectors } from 'apps/cms/store'
import { FsFolderObject } from 'shared/api/requests/cms/schemas'

export const useFolderByPath = (path: string): FsFolderObject => {
  const folder = useAppSelector((state) => contentManagementSelectors.getFolderByPath(state, path))

  if (!folder) {
    throw new FolderMissingError(path)
  }

  return folder
}
